import { render } from "./index.vue?vue&type=template&id=0660c2da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0660c2da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0660c2da"],['__file',"src/views/MyAccount/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0660c2da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0660c2da', __exports__)) {
    console.log('reload')
    api.reload('0660c2da', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0660c2da&scoped=true", () => {
    console.log('re-render')
    api.rerender('0660c2da', render)
  })

}


export default __exports__